import React from "react";
import {
  Box,
  Paper,
  Avatar,
  Typography,
  Chip,
  IconButton,
  Button,
} from "@mui/material";
import { DeleteOutline, PlayArrow } from "@mui/icons-material";
import PenPaperIcon from "../../../components/icons/PenPaperIcon";
import Ellipse from "../../../assets/ellipse890.png";
import { BookingResponse } from "../../bookings/types/view-booking";

interface HeaderCardProps {
  reduxTheme: any;
  bookingData: BookingResponse | null;
}
const HeaderCard: React.FC<HeaderCardProps> = ({ reduxTheme, bookingData }) => {
  return (
    <Paper
      sx={{
        p: 2,
        flex: 1,
        borderRadius: 3,
        fontWeight: "bold",
        width: "800px",
        height: "270px",
        boxShadow: 0,
        display: "flex", // ✅ ensures internal layout expands
        flexDirection: "column",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        boxShadow={0}
      >
        <Paper
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            width: 300,
            height: 180,
            boxShadow: 0,
            p: "2px 4px",
            borderRadius: 2,
            gap: 1,
          }}
        >
          <Avatar
            src={bookingData?.deceased[0].person_image || ""}
            alt="profile"
            sx={{
              mt: 2,
              bgcolor: reduxTheme.primary_colors?.[800],
              width: 150,
              height: 150,
            }}
            imgProps={{
              style: { objectFit: "cover", width: "100%", height: "100%" },
            }}
          />

          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            boxShadow={0}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mt: 1,
                flexWrap: "nowrap",
                boxShadow: 0,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  gap: 0.5,
                  mt: 4,
                  fontSize: "24px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  minWidth: 0,
                }}
              >
                {bookingData?.deceased[0].first_name}{" "}
                {bookingData?.deceased[0].surname}
              </Typography>
              <Chip
                label="Free"
                size="small"
                sx={{ opacity: 0.7, ml: 2, mt: 2, width: 51 }}
              />
            </Box>
            <Typography
              variant="subtitle1"
              sx={{ fontSize: "14px", fontWeight: 700 }}
            >
              {bookingData?.deceased[0]?.date_of_birth &&
                bookingData?.deceased[0]?.date_of_death && (
                  <>
                    {new Date(
                      bookingData.deceased[0].date_of_birth
                    ).getFullYear()}
                    –
                    {new Date(
                      bookingData.deceased[0].date_of_death
                    ).getFullYear()}
                  </>
                )}
            </Typography>

            <Typography variant="body2" sx={{ fontSize: "12px", opacity: 0.6,mt:1 }}>
              Created By {bookingData?.created_by?.first_name}{" "}
              {bookingData?.created_by?.last_name} on{" "}
              {bookingData?.created_at
                ? new Date(bookingData.created_at).toLocaleDateString("en-GB")
                : ""}
            </Typography>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 0.8, mt: 1.5 }}
            >
              <IconButton
                size="small"
                sx={{
                  width: 22,
                  height: 22,
                  bgcolor: "#D8FBF3",
                  color: "#0D9488",
                  borderRadius: "50%",
                }}
              >
                <PlayArrow sx={{ fontSize: 18 }} />
              </IconButton>
              <IconButton
                size="small"
                sx={{
                  width: 22,
                  height: 22,
                  bgcolor: "#FEF3C7",
                  color: "#D97706",
                  borderRadius: "50%",
                }}
              >
                <PenPaperIcon sx={{ fontSize: 17 }} />
              </IconButton>
              <IconButton
                size="small"
                sx={{
                  width: 22,
                  height: 22,
                  bgcolor: "#FBD8DF",
                  color: "#E11D48",
                  borderRadius: "50%",
                }}
              >
                <DeleteOutline sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          </Box>
        </Paper>

        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Button
            sx={{
              borderRadius: 3,
              bgcolor: "#007AFF26",
              color: "#007AFF",
              textTransform: "none",
            }}
          >
            Upgrade to premium
          </Button>
          <Button
            variant="outlined"
            sx={{
              borderRadius: 3,
              mt: 2,
              borderColor: " #007AFF26",
              color: "#007AFF",
              textTransform: "none",
              maxWidth: 250,
            }}
          >
            Convert To Booking
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default HeaderCard;
